import actions from 'state/constants';

// Update state when starting to fetch new data from API
const fetchingUpsellsDataReducer = state => ({
  ...state,
  isBeingFetched: true,
});

// Update state when finished fetching new data from API
const fetchedUpsellsDataReducer = (state, action) => ({
  ...state,
  isBeingFetched: false,
  data: action.payload.upsells,
});

// Figure out how to update state based on incoming action type
export const reducer = (state = {}, action) => {
  switch (action.type) {
    case actions.FETCH_UPSELLS_REQUEST:
      return fetchingUpsellsDataReducer(state, action);
    case actions.FETCH_UPSELLS_SUCCESS:
      return fetchedUpsellsDataReducer(state, action);

    default:
      return state;
  }
};

export default reducer;
